import { jobSectionMap } from './jobSectionMap';

const electrical = new Set(['ElectricalOptions', 'UnregulatedPowerSupply', 'UnregulatedBreakers', 'RegulatedPowerSupply', 'RegulatedBreakers', 'SequenceOfOperations', 'Telemetry', 'TelemetryAccessories', 'ControlLogicOnly']);
const sales = new Set(['SoldToShipTo', 'PriceBreakdown', 'OwnersManual']);
const general = new Set(['GeneralProjectInfo', 'GeneralStationInfo']);
const mechanical = new Set(['HCRequirements', 'SkidConstruction', 'PumpManifoldPiping', 'StationEnclosure', 'DropPipeComments', 'DropPipes', 'LevelControls', 'FillSources', 'PumpParent', 'PumpDetails', 'WaterTreatmentToggles', 'InletScreen', 'InletStrainer', 'DischargeStrainer', 'DischargeFilter', 'ROSystem', 'UVSystem', 'Fertigation', 'SkyHarvester', 'ShipLoose']);
const normalize = value => String(value || '').replace(/[^a-z0-9]/gi, '').toLowerCase();

// Audit membership is authoritative; only enrich missing display metadata from
// this same job. Ambiguous fields stay visible without a guessed destination.
export function readFullJobTbdAudit(core) {
  const project = Array.isArray(core?.GeneralProjectInfo) ? core.GeneralProjectInfo[0] : core?.GeneralProjectInfo;
  return (Array.isArray(core?.TBDAudit) ? core.TBDAudit : [])
    .filter(row => row && typeof row.ColumnName === 'string' && row.ColumnName &&
      (row.ProjectID == null || project?.ID == null || String(row.ProjectID) === String(project.ID)))
    .map(row => {
      const matches = Object.keys(jobSectionMap).flatMap(section => {
        if (row.Table && normalize(row.Table) !== normalize(section)) return [];
        const records = Array.isArray(core[section]) ? core[section] : core[section] ? [core[section]] : [];
        return records.filter(record => record && Object.prototype.hasOwnProperty.call(record, row.ColumnName) &&
          (row.Zone == null || String(record.Zone) === String(row.Zone)))
          .map(record => ({ section, record }));
      });
      const match = matches.length === 1 ? matches[0] : null;
      const section = match?.section;
      const page = electrical.has(section) ? 'Electrical' : sales.has(section) ? 'Sales Information' :
        general.has(section) ? 'General' : mechanical.has(section) ? 'Mechanical' : undefined;
      return { ...row, ProjectID: row.ProjectID ?? project?.ID,
        Table: row.Table ?? section, Page: row.Page ?? page,
        Value: row.Value ?? match?.record[row.ColumnName] ?? 'TBD' };
    });
}
